import BaseModel from "../base/baseModel";
import OrigemEtapa from "../enum/origemEtapa";
import TipoEtapa from "../enum/tipoEtapa";

export default class EtapaPCPModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    ordem: number = null;
    ativo = true;
    obrigatorio = true;
    tipo: TipoEtapa = null;
    tipoDescricao: string = null;
    setorId: number = null;
    origemEtapa: OrigemEtapa = OrigemEtapa.Venda;
    origemEtapaDescricao: string = null;
}
